module.exports = __webpack_public_path__ + "img/4g2.e1a5a4ad.svg";